export interface ComparisonRow {
  id: number;
  name: string;
  basic: string | number | boolean | null;
  freedom: string | number | boolean;
  business: string | number | boolean;
  corporation: string | number | boolean;
  corporationPlus: string | number | boolean;
  corporationPlusFstec: string | number | boolean;
  groupName: string | null;
  groupType: string  | null;
  isGroup: boolean;
  parentId: number | null;
  hint: string | null;
}

export const comparisonRows: readonly ComparisonRow[] = Object.freeze([
  // ГРУППА: Стоимость
  {
    id: 1,
    name: 'Стоимость',
    basic: 'Бесплатно',
    freedom: 36000,
    business: 87000,
    corporation: 158000,
    corporationPlus: 396000,
    corporationPlusFstec: 648000,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: null,
    hint: null,
    isInfinity: false,
  },
  {
    id: 2,
    name: 'Количество одновременных управляющих соединений',
    basic: 1,
    freedom: 1,
    business: 3,
    corporation: 5,
    corporationPlus: 3,
    corporationPlusFstec: 3,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: null,
    hint: 'Соединение - исходящее подключение к удаленному устройству',
    isInfinity: false,
  },
  {
    id: 3,
    name: 'Количество управляющих устройств',
    basic: true,
    freedom: false,
    business: false,
    corporation: true,
    corporationPlus: false,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: null,
    hint: 'Количество устройств, которые можно использовать для исходящего соединения',
    isInfinity: true,
  },
  {
    id: 4,
    name: 'Лицензированные пользователи',
    basic: '',
    freedom: '',
    business: '',
    corporation: '',
    corporationPlus: '',
    corporationPlusFstec: '',
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: null,
    hint: 'Лицензированный пользователь - пользователь с активированной лицензией',
    isInfinity: true,
  },
  {
    id: 5,
    name: 'Модель внедрения',
    basic: 'Облачное решение',
    freedom: 'Облачное решение',
    business: 'Облачное решение',
    corporation: 'Облачное решение',
    corporationPlus: 'Серверное решение',
    corporationPlusFstec: 'Серверное решение',
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: null,
    hint: null,
    isInfinity: false,
  },
  {
    id: 6,
    name: 'Удаленное управление',
    basic: null,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: 'Удаленное управление',
    groupType: 'header',
    isGroup: true,
    parentId: null,
    hint: null,
    isInfinity: false,
  },
  {
    id: 7,
    name: 'Управление удаленным устройством через экран',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 6,
    hint: 'GUI',
    isInfinity: false,
  },
  {
    id: 8,
    name: 'Поддержка мультимониторных систем',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 6,
    hint: null,
    isInfinity: false,
  },
  {
    id: 9,
    name: 'Блокировка устройств ввода и скрытие экрана удаленного доступа',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 6,
    hint: null,
    isInfinity: false,
  },
  {
    id: 10,
    name: 'Скрытое подключение к устройству',
    basic: false,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 6,
    hint: 'Даёт возможность выполнять работу незаметно для пользователя, без отображения признаков удалённого доступа',
    isInfinity: false,
  },
  {
    id: 11,
    name: 'Проброс USB-токенов',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 6,
    hint: 'Позволяет использовать на удалённом рабочем месте локальные USB-токены, например, электронные подписи.',
    isInfinity: false,
  },
  {
    id: 12,
    name: 'Настройка TCP-туннелей',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 6,
    hint: 'Создает надёжные защищённые каналы между сетями, обеспечивая безопасный доступ к ресурсам в разных сегментах инфраструктуры.',
    isInfinity: false,
  },
  {
    id: 13,
    name: 'Видеозапись сеансов',
    basic: 'локально',
    freedom: 'локально',
    business: 'локально',
    corporation: 'локально',
    corporationPlus: 'на сервере или локально',
    corporationPlusFstec: 'на сервере или локально',
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 6,
    hint: 'Запись сеансов удаленного доступа для безопасности, контроля качества или учебных целей',
    isInfinity: false,
  },
  {
    id: 14,
    name: 'Поддержка горячих клавиш',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 6,
    hint: null,
    isInfinity: false,
  },
  {
    id: 15,
    name: 'Поддержка специальных команд Windows 8/10',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 6,
    hint: null,
    isInfinity: false,
  },
  {
    id: 16,
    name: 'Передача звука с удаленного устройства',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 6,
    hint: null,
    isInfinity: false,
  },
  {
    id: 17,
    name: 'Удаленная печать',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 6,
    hint: 'Печать документов с удаленного устройства на локальном принтере',
    isInfinity: false,
  },
  {
    id: 18,
    name: 'Групповое подключение к удаленному устройству',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 6,
    hint: null,
    isInfinity: false,
  },
  {
    id: 19,
    name: 'Общий буфер обмена',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 6,
    hint: null,
    isInfinity: false,
  },
  {
    id: 20,
    name: 'Передача файлов с помощью drag-and-drop',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 6,
    hint: null,
    isInfinity: false,
  },
  {
    id: 21,
    name: 'Поддерживаемые ОС для Сервера',
    basic: null,
    freedom: '',
    business: '',
    corporation: '',
    corporationPlus: '',
    corporationPlusFstec: '',
    groupName: 'Поддерживаемые ОС для Сервера',
    groupType: 'header',
    isGroup: true,
    parentId: null,
    hint: null,
    isInfinity: false,
  },
  {
    id: 22,
    name: 'Windows',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 21,
    hint: null,
    isInfinity: false,
  },
  {
    id: 23,
    name: 'Linux',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 21,
    hint: 'В том числе российские платформы',
    isInfinity: false,
  },
  {
    id: 24,
    name: 'Поддерживаемые ОС – Клиентское приложение',
    basic: null,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: false,
    corporationPlusFstec: false,
    groupName: 'Поддерживаемые ОС – Клиентское приложение',
    groupType: 'header',
    isGroup: true,
    parentId: null,
    hint: null,
    isInfinity: false,
  },
  {
    id: 25,
    name: 'Windows',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 24,
    hint: null,
    isInfinity: false,
  },
  {
    id: 26,
    name: 'Linux',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 24,
    hint: null,
    isInfinity: false,
  },
  {
    id: 27,
    name: 'Android',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 24,
    hint: null,
    isInfinity: false,
  },
  {
    id: 28,
    name: 'Mac OS',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 24,
    hint: null,
    isInfinity: false,
  },
  // {
  //   id: 29,
  //   name: 'iOS',
  //   basic: true,
  //   freedom: true,
  //   business: true,
  //   corporation: true,
  //   corporationPlus: true,
  //   corporationPlusFstec: true,
  //   groupName: null,
  //   groupType: null,
  //   isGroup: false,
  //   parentId: 24,
  //   hint: null,
  //   isInfinity: false,
  // },
  {
    id: 30,
    name: 'Российские платформы',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 24,
    hint: 'Astra Linux, ALT Linux, РЕД ОС, РОСА, ОСнова, Стрелец, Alter OS, SberLinux OS, Goslinux',
    isInfinity: false,
  },
  {
    id: 31,
    name: 'Поддержка мобильных устройств',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 24,
    hint: `
      Управление различными типами устройств (смартфоны, планшеты, контрольно-кассовые аппараты и т.д).
      Подключение к устройству на любой поддерживаемой ОС. Настройка основных параметров через MDM системы.
      Сенсорное переключение между удаленными мониторами.
    `,
    isInfinity: false,
  },
  {
    id: 32,
    name: 'Терминальный доступ Windows, Linux',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 24,
    hint: null,
    isInfinity: false,
  },
  {
    id: 33,
    name: 'Функции сервисного доступа',
    basic: null,
    freedom: '',
    business: '',
    corporation: '',
    corporationPlus: '',
    corporationPlusFstec: '',
    groupName: 'Функции сервисного доступа',
    groupType: 'header',
    isGroup: true,
    parentId: null,
    hint: 'Техническая поддержка и настройка ПК без перехвата управления',
    isInfinity: false,
  },
  {
    id: 34,
    name: 'Передача файлов между устройствами',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 33,
    hint: null,
    isInfinity: false,
  },
  {
    id: 35,
    name: 'Редактирование реестра',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 33,
    hint: null,
    isInfinity: false,
  },
  {
    id: 36,
    name: 'Управление диспетчером задач',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 33,
    hint: null,
    isInfinity: false,
  },
  {
    id: 37,
    name: 'Настройка компьютера через командную строку',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 33,
    hint: null,
    isInfinity: false,
  },
  {
    id: 38,
    name: 'Wake-on-LAN',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 33,
    hint: null,
    isInfinity: false,
  },
  {
    id: 39,
    name: 'Возможность доступа с повышенными правами к файлам управляемого устройства',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 33,
    hint: null,
    isInfinity: false,
  },
  {
    id: 40,
    name: 'Обмен сторонами',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 33,
    hint: null,
    isInfinity: false,
  },
  {
    id: 41,
    name: 'Встроенный функционал приема и обработки заявок на поддержку',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 33,
    hint: 'HelpDesk',
    isInfinity: false,
  },
  {
    id: 42,
    name: 'Текстовый, аудио и видео чаты во время сессии',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 33,
    hint: null,
    isInfinity: false,
  },
  {
    id: 43,
    name: 'Администрирование',
    basic: null,
    freedom: '',
    business: '',
    corporation: '',
    corporationPlus: '',
    corporationPlusFstec: '',
    groupName: 'Администрирование',
    groupType: 'header',
    isGroup: true,
    parentId: null,
    hint: null,
    isInfinity: false,
  },
  {
    id: 44,
    name: 'Управление структурой организации',
    basic: false,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 43,
    hint: 'Адресная книга',
    isInfinity: false,
  },
  {
    id: 45,
    name: 'Ведение сотрудников организации',
    basic: false,
    freedom: false,
    business: false,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 43,
    hint: null,
    isInfinity: false,
  },
  {
    id: 46,
    name: 'Централизованное управление настройками политик безопасности устройств',
    basic: false,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 43,
    hint: null,
    isInfinity: false,
  },
  {
    id: 47,
    name: 'Настройка политик доступа к устройствам для групп пользователей',
    basic: false,
    freedom: false,
    business: false,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 43,
    hint: null,
    isInfinity: false,
  },
  {
    id: 48,
    name: 'Синхронизация устройств и учетных записей со службами каталогов Windows и Linux',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 43,
    hint: null,
    isInfinity: false,
  },
  {
    id: 49,
    name: 'Управление терминальными серверами',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 43,
    hint: 'Настройка постоянного доступа к терминальным серверам',
    isInfinity: false,
  },
  {
    id: 50,
    name: 'Настройка системы',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 43,
    hint: `
      Настройка ролей доступа, внутреннее лицензирование,
      управление регистрацией пользователей, настройка типа аутентификации,
      настройки безопасности
    `,
    isInfinity: false,
  },
  {
    id: 51,
    name: 'Управление клиентскими сессиями',
    basic: false,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 43,
    hint: null,
    isInfinity: false,
  },
  {
    id: 52,
    name: 'Удаленная установка приложений на устройства в локальной сети',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 43,
    hint: 'Только Windows',
    isInfinity: false,
  },
  {
    id: 53,
    name: 'Поиск устройств в локальной сети',
    basic: false,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 43,
    hint: null,
    isInfinity: false,
  },
  {
    id: 54,
    name: 'Инвентаризация оборудования и ПО',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 43,
    hint: null,
    isInfinity: false,
  },
  {
    id: 55,
    name: 'Статистика',
    basic: false,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 43,
    hint: `
      Содержит подробную информацию о сессиях устройств: общее время на устройстве пользователя,
      количество установленных соединений, время соединения между устройствами за определенный период
    `,
    isInfinity: false,
  },
  {
    id: 56,
    name: 'Управление конфигурациями (UEM)',
    basic: null,
    freedom: '',
    business: '',
    corporation: '',
    corporationPlus: '',
    corporationPlusFstec: '',
    groupName: 'Управление конфигурациями (UEM)',
    groupType: 'header',
    isGroup: true,
    parentId: null,
    hint: null,
    isInfinity: false,
  },
  {
    id: 57,
    name: 'Массовая установка/переустановка/деинсталляция ПО',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: false,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 56,
    hint: null,
    isInfinity: false,
  },
  {
    id: 58,
    name: 'Управление службами ОС',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: false,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 56,
    hint: null,
    isInfinity: false,
  },
  {
    id: 59,
    name: 'Управление политиками конфигураций',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: false,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 56,
    hint: null,
    isInfinity: false,
  },
  // {
  //   id: 60,
  //   name: 'Удаленная установка ОС',
  //   basic: false,
  //   freedom: false,
  //   business: false,
  //   corporation: false,
  //   corporationPlus: true,
  //   corporationPlusFstec: false,
  //   groupName: null,
  //   groupType: null,
  //   isGroup: false,
  //   parentId: 56,
  //   hint: null,
  //   isInfinity: false,
  // },
  {
    id: 61,
    name: 'Удаленное исполнение скриптов',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: false,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 56,
    hint: null,
    isInfinity: false,
  },
  {
    id: 62,
    name: 'Написание собственных сценариев',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: false,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 56,
    hint: null,
    isInfinity: false,
  },
  {
    id: 63,
    name: 'Отчеты по результатам исполнения задач',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: false,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 56,
    hint: null,
    isInfinity: false,
  },
  {
    id: 64,
    name: 'Безопасность',
    basic: null,
    freedom: '',
    business: '',
    corporation: '',
    corporationPlus: '',
    corporationPlusFstec: '',
    groupName: 'Безопасность',
    groupType: 'header',
    isGroup: true,
    parentId: null,
    hint: null,
    isInfinity: false,
  },
  {
    id: 65,
    name: 'Постоянные и временные пароли',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: null,
    isInfinity: false,
  },
  {
    id: 66,
    name: 'Двухфакторная аутентификация',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: 'Электронная почта, мессенджер MAX',
    isInfinity: false,
  },
  {
    id: 67,
    name: 'Защита данных при передаче',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: 'TLS 1.3',
    isInfinity: false,
  },
  {
    id: 68,
    name: 'Шифрование AES-256',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: null,
    isInfinity: false,
  },
  {
    id: 69,
    name: 'Поддержка SSO',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: 'Посредством интеграции с Keycloak',
    isInfinity: false,
  },
  {
    id: 70,
    name: 'Детализированная настройка прав и политик доступа для защиты устройств',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: null,
    isInfinity: false,
  },
  {
    id: 71,
    name: 'Служебные устройства',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: `
      Авторизация со служебного устройства предоставляет доступ к полному списку устройств
      организации для подключения в соответствии с назначенными политиками доступа.
      При входе с личного или иного устройства доступ ограничивается Базовой политикой безопасности.
    `,
    isInfinity: false,
  },
  {
    id: 72,
    name: 'Режим конфиденциальности',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: `
      Включение “черного экрана” защищает ваши данные от третьих лиц: 
      экран управляемого устройства становится черным, средства ввода блокируются,
      а все ваши действия недоступны для просмотра посторонним.
   `,
    isInfinity: false,
  },
  {
    id: 73,
    name: 'Блокировка приложения при бездействии',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: 'С возможностью централизованной настройки для редакций Корпорация, Корпорация + и Корпорация + ФСТЭК',
    isInfinity: false,
  },
  {
    id: 74,
    name: 'Протоколирование действий пользователей',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: 'Во время сеанса удаленного управления',
    isInfinity: false,
  },
  {
    id: 75,
    name: 'Регистрация действий пользователей',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: `
      История событий, связанных с управлением устройствами,
      настройкой политик доступа и администрированием в рамках организации (Журнал организации).
    `,
    isInfinity: false,
  },
  {
    id: 76,
    name: 'Регистрация событий безопасности',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: `
      Хранение и отображение всех действий, совершенных в Личном кабинете
      и Клиентском приложении всеми пользователями системы (Системный журнал)
    `,
    isInfinity: false,
  },
  {
    id: 77,
    name: 'Контроль подмены сторон взаимодействия и модификации передаваемой информации',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: null,
    isInfinity: false,
  },
  {
    id: 78,
    name: 'Сертификат ФСТЭК России',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: false,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: null,
    isInfinity: false,
  },
  {
    id: 79,
    name: 'Хранение данных на своем сервере',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 64,
    hint: null,
    isInfinity: false,
  },
  {
    id: 80,
    name: 'Интеграция со сторонними системами',
    basic: null,
    freedom: '',
    business: '',
    corporation: '',
    corporationPlus: '',
    corporationPlusFstec: '',
    groupName: 'Безопасность',
    groupType: 'header',
    isGroup: true,
    parentId: null,
    hint: null,
    isInfinity: false,
  },
  {
    id: 81,
    name: 'Интеграция с AD, LDAP',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 80,
    hint: 'Служба каталогов',
    isInfinity: false,
  },
  {
    id: 82,
    name: 'Интеграция с SIEM',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 80,
    hint: null,
    isInfinity: false,
  },
  {
    id: 83,
    name: 'Интеграция с Keycloak',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 80,
    hint: null,
    isInfinity: false,
  },
  {
    id: 84,
    name: 'Возможности расширения лицензии',
    basic: null,
    freedom: '',
    business: '',
    corporation: '',
    corporationPlus: '',
    corporationPlusFstec: '',
    groupName: 'Возможности расширения лицензии',
    groupType: 'header',
    isGroup: true,
    parentId: null,
    hint: null,
    isInfinity: false,
  },
  {
    id: 85,
    name: 'Дополнительные соединения',
    basic: false,
    freedom: false,
    business: false,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 84,
    hint: null,
    isInfinity: false,
  },
  {
    id: 86,
    name: 'Дополнительные управляющие серверы',
    basic: false,
    freedom: false,
    business: false,
    corporation: false,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: 84,
    hint: null,
    isInfinity: false,
  },
  {
    id: 87,
    name: 'Массовое развертывание',
    basic: false,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: null,
    hint: 'MSI пакет',
    isInfinity: false,
  },
  {
    id: 88,
    name: 'Техническая поддержка',
    basic: true,
    freedom: true,
    business: true,
    corporation: true,
    corporationPlus: true,
    corporationPlusFstec: true,
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: null,
    hint: `
      Включает базовую поддержку для всех версий продукта. 
      Пользователям, использующим коммерческие редакции на договорной основе или продлившим техническую поддержку,
      предоставляется расширенная (гарантийная или постгарантийная) техподдержка в течение срока,
      указанного в договоре.
    `,
    isInfinity: false,
  },
  {
    id: 89,
    name: '',
    basic: 'скачать',
    freedom: 'купить',
    business: 'купить',
    corporation: 'купить',
    corporationPlus: 'купить',
    corporationPlusFstec: 'купить',
    groupName: null,
    groupType: null,
    isGroup: false,
    parentId: null,
    hint: null,
    isInfinity: false,
  }
]);
